import { create } from "zustand";
import { persist } from "zustand/middleware";

type SessionStore = {
  currentUserId: string | null;
  currentTenantId: string | null;
  setCurrentUserId: (id: string) => void;
  setCurrentTenantId: (id: string) => void;
  reset: () => void;
};

export const useSessionStore = create<SessionStore>()(
  persist(
    (set) => ({
      currentUserId: null,
      currentTenantId: null,
      setCurrentUserId: (id) => set({ currentUserId: id }),
      setCurrentTenantId: (id) => set({ currentTenantId: id }),
      reset: () => set({ currentUserId: null, currentTenantId: null }),
    }),
    {
      name: "signal7-session",
    },
  ),
);
